import { useEffect, useState } from "react";
import { useApi } from "./index";

/** Object URLs of photos already fetched, by address; null = the directory has none. Kept for the page's life. */
const photos = new Map<string, Promise<string | null>>();

/**
 * The directory photo of a staff member (`AuthUser.photoUrl`, Microsoft Entra ID read at sign-in) as an address an `<img>` can show: the API
 * needs the bearer token, so the photo is fetched once and kept as an object URL. Null while loading, without a photo and on any error, so
 * the avatar shows its initials.
 */
export function useUserPhoto(photoUrl?: string | null): string | null {
  const api = useApi();
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    if (!photoUrl) {
      setSrc(null);
      return;
    }
    let alive = true;
    let pending = photos.get(photoUrl);
    if (!pending) {
      pending = api
        .blob(photoUrl)
        .then((blob) => (blob && blob.type.startsWith("image/") ? URL.createObjectURL(blob) : null))
        .catch(() => null);
      photos.set(photoUrl, pending);
    }
    void pending.then((url) => alive && setSrc(url));
    return () => {
      alive = false;
    };
  }, [api, photoUrl]);
  return src;
}
